import { render, staticRenderFns } from "./ConnectTelegram.vue?vue&type=template&id=6dc69c69&scoped=true"
import script from "./ConnectTelegram.vue?vue&type=script&lang=js"
export * from "./ConnectTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc69c69",
  null
  
)

export default component.exports